import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as R from 'ramda'

import TextField from 'material-ui/TextField'
import MenuItem from 'material-ui/MenuItem';

import Select from 'components/Select'

import dataActions from 'actions/dataActions'

import { doc, dirtyRead } from '../selectors/common'
import { managers } from '../selectors/entities'

let select = dirtyRead(
	(state, props) => ({
		object: doc(state, props.objectID)
	  , managers: managers(state)
	})
)

export class ManagerSelect extends Component{
	render(){
		let { props } = this
		return(
			<Select
				hintText="Select manager"
				title="Please choose manager"
				value={props.object.managerID}
				icon= {
					<img
						src={'/' + process.env.REACT_APP_NAME + "/static/img/svg-icon/managers_green.svg"}
						className="left-navigation-icons"
						style={{
							height: "20px"
						  , position: "relative"
						  , display: "block"
						  , marginLeft: "5px"
						}}
					/>
				}
				onChange={(evt, indx, value)=> props.STAGE({_id: props.objectID, managerID: value})}
				style={{
					marginLeft: "10px"
				}}
			>
				{R.values(R.map(manager => <MenuItem key={manager._id} value={manager._id} primaryText={manager.name} />, props.managers))}
			</Select>
		)
	}
}

export default connect(select, dataActions)(ManagerSelect)



// WEBPACK FOOTER //
// ./src/components/ManagerSelect.js